import styled from "styled-components";

export const SessionBanner = styled.div`
    position: fixed;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;

    display: flex;
    align-items: center;
    gap: 0.75rem;
    max-width: min(90vw, 640px);
    padding: 0.75rem 1rem;

    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.md};
    box-shadow: ${(props) => props.theme.shadowMd};
    color: ${(props) => props.theme.text};
    font-size: ${(props) => props.theme.type.body};

    i {
        font-size: 1.25rem;
        flex-shrink: 0;
        color: ${(props) => props.theme.warn};
    }
`;

export const SessionBannerText = styled.span`
    flex: 1;
    line-height: 1.35;
`;

export const SessionBannerButton = styled.button`
    flex-shrink: 0;
    padding: 0.45rem 0.9rem;
    border: none;
    border-radius: ${(props) => props.theme.radius.sm};
    cursor: pointer;
    font-size: 0.85rem;
    font-family: inherit;
    font-weight: 700;
    background: ${(props) => props.theme.accent};
    color: ${(props) => props.theme.onAccent};

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.accentHover};
    }

    &:disabled {
        opacity: 0.6;
        cursor: default;
    }
`;
